// shared/analytics/events.ts
/**
 * Named events — prop types and the runtime allowlist of prop KEYS.
 * Deliberately zod-free: the tracker imports this into both public bundles.
 * The server-side VALUE schemas live in ./payload.ts and are pinned to these keys by a test.
 */
import type { EventName, EnquiryVia, FunnelStep } from './enums';

type NoProps = Record<never, never>;

export interface EventPropsMap {
  date_checked: { avail: boolean };
  funnel_step: { step: FunnelStep };
  pricing_viewed: NoProps;
  whatsapp_clicked: { p: string };
  tel_clicked: { p: string };
  call_started: NoProps;
  call_connected: NoProps;
  enquiry_sent: { via: EnquiryVia };
  checkout_started: NoProps;
  rsvp_sent: NoProps;
  live_watch: NoProps;
}

export const EVENT_PROP_KEYS: { readonly [K in EventName]: readonly string[] } = {
  date_checked: ['avail'],
  funnel_step: ['step'],
  pricing_viewed: [],
  whatsapp_clicked: ['p'],
  tel_clicked: ['p'],
  call_started: [],
  call_connected: [],
  enquiry_sent: ['via'],
  checkout_started: [],
  rsvp_sent: [],
  live_watch: [],
};
